import Vue from 'vue';
import SERVICES from '@/constants/services';
import { mapGetters } from 'vuex';
import { LevelName } from './types';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'commonConfirmGAPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    watch: {
        'form.fields.GACode.valid'(v) {
            if (!v)
                this.$store.commit('popupModule/setSlotData', { responseErrors: [] });
            if (v && this.form.fields.GACode.value.length > 0) {
                this.$store.commit('popupModule/setSlotData', { isLoading: true });
                setTimeout(() => {
                    this.$emit('onSubmit', { code_ga: this.form.fields.GACode.value });
                }, 1000);
            }
        },
        'form.fields.GACode.value'() {
            this.$store.commit('popupModule/setSlotData', { responseErrors: [] });
        }
    },
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    data: () => ({
        form: {
            fields: {
                GACode: {
                    valid: false,
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `${SERVICES.CODE_LENGTH}-значный код`
                    ],
                    errorsBucket: []
                }
            }
        }
    }),
    methods: {
        hasntAccessHandler() {
            const hasCurrentMethod = this.getUserData.currentAccessRepairMethods.includes('ga');
            const vm = this;
            if (hasCurrentMethod) {
                this.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: true,
                    title: 'Предупреждение',
                    content: 'В данный момент идет восстановление Google Authenticator, установленного как метод 2FA для подтверждения операций в Личном кабинете. Вы сможете выполнить операцию после завершения восстановления.',
                    actions: [
                        {
                            title: 'Хорошо',
                            isAccent: true,
                            callback() { vm.$store.commit('popupModule/setClosed'); }
                        }
                    ]
                });
                return;
            }
            const isBasic = this.getUserData.verificationRights.levelName === LevelName.basic;
            if (isBasic) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: false,
                    title: 'Восстановление Google Authenticator',
                    content: 'Чтобы восстановить Google Authenticator, нужно пройти расширенную верификацию аккаунта.',
                    actions: [
                        {
                            title: 'К разделу',
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                                window.location.href = getPassportUrl('/id/', { withAcceptor: true });
                            }
                        },
                        {
                            title: 'Позже',
                            isAccent: false,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
                return;
            }
            this.$router.push({ name: 'AccessRepair', query: { secondFactor: 'ga', an3K8QkkJb3Mzz: this.slotData.sessionId } });
        }
    }
});
